import React from "react"
import { Dialog, DialogProps, styled } from "@mui/material"

type Props = React.HTMLAttributes<HTMLDivElement> & DialogProps

const SheetComponent = styled(({ children, ...restProps }: Props) => {
  return <Dialog {...restProps}>{children}</Dialog>
})(({ theme }) => ({
  "& .MuiDialog-container": {
    position: "absolute",
    right: "24px",
    bottom: "24px",
    [theme.breakpoints.down("md")]: {
      position: "relative",
      right: "initial",
      bottom: "initial",
    },
    "& .MuiDialog-paper": {
      alignSelf: "flex-end",
      borderRadius: "24px",
      boxShadow: "none",
      margin: "0",
      padding: "24px 0",
      [theme.breakpoints.down("lg")]: {
        padding: "16px 0",
      },
      [theme.breakpoints.down("md")]: {
        borderRadius: "0",
        borderTopLeftRadius: "15px",
        borderTopRightRadius: "15px",
      },
    },
    "& .MuiDialogContent-root": {
      position: "relative",
    },
  },
}))

export default SheetComponent
